export default "__VITE_ASSET__CUDlRscD__"